"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createCartApi = void 0;
var tslib_1 = require("tslib");
var withHttpClient_1 = require("../hocs/withHttpClient");
var cartApi = function cartApi(_a) {
  var httpClient = _a.httpClient;
  var createCart = function createCart(clientId) {
    return tslib_1.__awaiter(void 0, void 0, void 0, function () {
      var res;
      return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, httpClient.post({
              endpoint: "payments/carts",
              data: {
                clientId: clientId
              }
            })];
          case 1:
            res = _a.sent();
            return [2, res.data.data];
        }
      });
    });
  };
  var deleteCart = function deleteCart(cartId) {
    return tslib_1.__awaiter(void 0, void 0, void 0, function () {
      var res;
      return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, httpClient.remove({
              endpoint: "payments/carts/".concat(cartId)
            })];
          case 1:
            res = _a.sent();
            return [2, res.data.data];
        }
      });
    });
  };
  var addItemToCart = function addItemToCart(cartId, cartItem) {
    return tslib_1.__awaiter(void 0, void 0, void 0, function () {
      var res;
      return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, httpClient.post({
              endpoint: "payments/carts/".concat(cartId, "/items"),
              data: cartItem
            })];
          case 1:
            res = _a.sent();
            return [2, res.data.data];
        }
      });
    });
  };
  var deleteCartItem = function deleteCartItem(cartId, itemId) {
    return tslib_1.__awaiter(void 0, void 0, void 0, function () {
      var res;
      return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, httpClient.remove({
              endpoint: "payments/carts/".concat(cartId, "/items/").concat(itemId)
            })];
          case 1:
            res = _a.sent();
            return [2, res.data.data];
        }
      });
    });
  };
  var fetchCartItem = function fetchCartItem(cartId, itemId) {
    return tslib_1.__awaiter(void 0, void 0, void 0, function () {
      var res;
      return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, httpClient.get({
              endpoint: "payments/carts/".concat(cartId, "/items/").concat(itemId)
            })];
          case 1:
            res = _a.sent();
            return [2, res.data.data];
        }
      });
    });
  };
  var updateCartItem = function updateCartItem(cartId, itemId, cartItem) {
    return tslib_1.__awaiter(void 0, void 0, void 0, function () {
      var res;
      return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, httpClient.put({
              endpoint: "payments/carts/".concat(cartId, "/items/").concat(itemId),
              data: cartItem
            })];
          case 1:
            res = _a.sent();
            return [2, res.data.data];
        }
      });
    });
  };
  var fetchCartById = function fetchCartById(cartId) {
    return tslib_1.__awaiter(void 0, void 0, void 0, function () {
      var res;
      return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, httpClient.get({
              endpoint: "payments/carts/".concat(cartId)
            })];
          case 1:
            res = _a.sent();
            return [2, res.data.data];
        }
      });
    });
  };
  var fetchClientCarts = function fetchClientCarts(clientId) {
    return tslib_1.__awaiter(void 0, void 0, void 0, function () {
      var res;
      return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, httpClient.get({
              endpoint: "payments/clients/".concat(clientId, "/carts")
            })];
          case 1:
            res = _a.sent();
            return [2, res.data.data];
        }
      });
    });
  };
  var convertCartToOrder = function convertCartToOrder(clientId, cart_id, queryParams) {
    return tslib_1.__awaiter(void 0, void 0, void 0, function () {
      var res;
      return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, httpClient.post({
              endpoint: "payments/clients/".concat(clientId, "/orders"),
              data: {
                cart_id: cart_id
              },
              queryParams: queryParams
            })];
          case 1:
            res = _a.sent();
            return [2, res.data.data];
        }
      });
    });
  };
  var cancelSubscriptions = function cancelSubscriptions(client_code, subscription_id, data) {
    return tslib_1.__awaiter(void 0, void 0, void 0, function () {
      var res;
      return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, httpClient.post({
              endpoint: 'payments/subscriptions/cancel',
              data: {
                client_code: client_code,
                subscription_id: subscription_id,
                data: data
              }
            })];
          case 1:
            res = _a.sent();
            return [2, res.data];
        }
      });
    });
  };
  return {
    createCart: createCart,
    deleteCart: deleteCart,
    addItemToCart: addItemToCart,
    deleteCartItem: deleteCartItem,
    fetchCartItem: fetchCartItem,
    updateCartItem: updateCartItem,
    fetchCartById: fetchCartById,
    fetchClientCarts: fetchClientCarts,
    convertCartToOrder: convertCartToOrder,
    cancelSubscriptions: cancelSubscriptions
  };
};
exports.createCartApi = (0, withHttpClient_1.withHttpClient)(cartApi);